<script>
// Caixa de recomendação verde reutilizável. Markup fixo (ícone lamp-on + título
// + texto), usada tanto na "Ação recomendada" (card da nota) quanto no "Como
// melhorar" (cada critério) da aba Avaliação — assim ficam byte-idênticas.
export default {
  name: 'TranscriptRecommendationBox',
  props: {
    title: { type: String, default: '' },
    text: { type: String, default: '' },
  },
}
</script>

<template>
  <div class="transcript-recommendation-box rounded-sm pa-3">
    <span class="d-inline-flex align-center mb-1">
      <icon-svg name="lamp-on" size="16" color="var(--success)" class="mr-2" />
      <span class="az-text-primary az-size-12 font-semibold">{{ title }}</span>
    </span>
    <p class="az-text-primary az-size-14 mb-0">{{ text }}</p>
  </div>
</template>

<style lang="sass" scoped>
// Tint claro do success (token global --transcript-success-bg-soft) — mesmo
// fundo compartilhado com a caixa de recomendação do card de nota
// (transcript-reason-action).
.transcript-recommendation-box
  background-color: var(--transcript-success-bg-soft)
</style>
